const DefaultPinData = {
  collection_description: null,
  collection_id: null,
  collection_image: null,
  collection_title: null,
  display_data: "product",
  icon_url: null,
  left: null,
  master_id: null,
  pin_background: "rgba(0, 0, 0, 0.8)",
  pin_border: "#fff",
  pin_dot: "#fff",
  pin_hover_background: "rgba(0, 0, 0, 0.6)",
  pin_hover_border: "#fefff1",
  pin_hover_dot: "#fefff1",
  popup_animation_in: "scaleIn",
  popup_animation_out: "scaleOut",
  popup_background: "#fff",
  popup_shadow_color: "rgba(0, 0, 0, 0.1)",
  popup_title_color: "#222",
  popup_title_font_style: "normal",
  popup_title_font_weight: "400",
  popup_title_size: "16",
  preset_name: null,
  product_btn_one: "VIEW ITEM",
  product_btn_one_bg: "#222",
  product_btn_one_color: "#fff",
  product_btn_one_font_style: "normal",
  product_btn_one_font_weight: "400",
  product_btn_one_hover_bg: "#d45729",
  product_btn_one_hover_color: "#fff",
  product_btn_one_open: "new",
  product_btn_one_size: "14",
  product_btn_two: "ADD TO CART",
  product_btn_two_bg: "#222",
  product_btn_two_color: "#fff",
  product_btn_two_font_style: "normal",
  product_btn_two_font_weight: "400",
  product_btn_two_hover_bg: "#d45729",
  product_btn_two_hover_color: "#fff",
  product_btn_two_size: "14",
  product_description: null,
  product_description_color: "#7f7f7f",
  product_description_font_style: "normal",
  product_description_font_weight: "400",
  product_description_size: "16",
  product_handle: null,
  product_id: null,
  product_price_color: "#d45729",
  product_price_font_style: "normal",
  product_price_font_weight: "400",
  product_price_size: "26",
  product_title: null,
  product_title_color: "#565656",
  product_title_font_style: "normal",
  product_title_font_weight: "400",
  product_title_size: "16",
  product_unavailable: "Unavailable",
  added_to_cart_text: 'Item added to cart!',
  product_variants: null,
  quickview_animation_in: "scaleIn",
  quickview_animation_out: "scaleOut",
  quickview_background: "#fff",
  quickview_close_color: "#d7d9d8",
  quickview_close_hover_color: "#d45729",
  quickview_enable_image: true,
  quickview_height: "312",
  quickview_line_color: "#d7d9d8",
  quickview_position: "right",
  quickview_shadow_color: "rgba(0, 0, 0, 0.1)",
  quickview_width: "368",
  preset_id: null,
  top: null
}

export default DefaultPinData
